import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ReactComponent as Arrow } from "images/svg/curvedArrow.svg";
import Icon1 from "images/png/rated-afrika-playlist-user-icon.png";
import Icon2 from "images/png/rated-afrika-playlist-upload-icon.png";
import Icon3 from "images/png/rated-afrika-playlist-checkmark-badge.png";

const HowToGetFeatured = () => {
  const ItemData = [
    {
      icon: Icon1,
      mainText: "Create Account",
      supportingText: "Get started by creating an account on Rated Afrika"
    },
    {
      icon: Icon2,
      mainText: "Upload Your Music",
      supportingText:
        "Share your music for consideration of being on our playlist"
    },
    {
      icon: Icon3,
      mainText: "Get Approved",
      supportingText: "Our team curates the best songs weekly"
    }
  ];
  return (
    <Container>
      <Typography
        align="center"
        size="3.6rem"
        m_size="4xl"
        weight="bold"
        mb="2"
      >
        How to Get Featured?
      </Typography>
      <Typography align="center" size="2xl" m_size="lg" color={Colors.grey600}>
        Be a Part of the Playlist
      </Typography>
      <Items>
        {ItemData.map((item, i) => {
          return (
            <Item key={i}>
              <Step>
                <IconBody>
                  <Icon src={item.icon} alt={`${item.mainText} img`} />
                </IconBody>

                <Typography weight="bold" size="2xl" mb="0.8">
                  {item.mainText}
                </Typography>
                <Typography size="lg" color={Colors.grey500} align="center">
                  {item.supportingText}
                </Typography>
              </Step>
              {i !== 2 && (
                <CurvedArrow variant={i !== 0}>
                  <Arrow />
                </CurvedArrow>
              )}
              {i !== 2 && (
                <StraightArrow>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="7"
                    height="31"
                    viewBox="0 0 7 31"
                    fill="none"
                  >
                    <path
                      d="M4 0.956055C4 0.679912 3.77614 0.456055 3.5 0.456055C3.22386 0.456055 3 0.679912 3 0.956055H4ZM3.5 30.4561L6.38675 25.4561H0.613249L3.5 30.4561ZM3 2.7998C3 3.07595 3.22386 3.2998 3.5 3.2998C3.77614 3.2998 4 3.07595 4 2.7998H3ZM4 6.4873C4 6.21116 3.77614 5.9873 3.5 5.9873C3.22386 5.9873 3 6.21116 3 6.4873H4ZM3 10.1748C3 10.4509 3.22386 10.6748 3.5 10.6748C3.77614 10.6748 4 10.4509 4 10.1748H3ZM4 13.8623C4 13.5862 3.77614 13.3623 3.5 13.3623C3.22386 13.3623 3 13.5862 3 13.8623H4ZM3 17.5498C3 17.8259 3.22386 18.0498 3.5 18.0498C3.77614 18.0498 4 17.8259 4 17.5498H3ZM4 21.2373C4 20.9612 3.77614 20.7373 3.5 20.7373C3.22386 20.7373 3 20.9612 3 21.2373H4ZM3 24.9248C3 25.2009 3.22386 25.4248 3.5 25.4248C3.77614 25.4248 4 25.2009 4 24.9248H3ZM4 28.6123C4 28.3362 3.77614 28.1123 3.5 28.1123C3.22386 28.1123 3 28.3362 3 28.6123H4ZM3 0.956055V2.7998H4V0.956055H3ZM3 6.4873V10.1748H4V6.4873H3ZM3 13.8623V17.5498H4V13.8623H3ZM3 21.2373V24.9248H4V21.2373H3Z"
                      fill="#FEC667"
                    />
                  </svg>
                </StraightArrow>
              )}
            </Item>
          );
        })}
      </Items>
    </Container>
  );
};

export default HowToGetFeatured;

const Container = styled.div`
  margin-bottom: 8rem;
`;

const Items = styled.div`
  display: flex;
  gap: 1.6rem;
  margin-top: 2.4rem;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
  }
`;
const Item = styled.div`
  display: flex;
  gap: 1.6rem;
  align-items: center;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
  }
`;
const Step = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 27rem;
`;

const IconBody = styled.div`
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  background: #2c2c2c;
  border: 8px solid #1e1e1e;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
`;

const Icon = styled.img`
  width: 2.4rem;
  height: 2.4rem;
`;

const CurvedArrow = styled.div<{ variant: boolean }>`
  transform: ${(props) => (props.variant ? "scaleY(-1)" : "")};
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const StraightArrow = styled.div`
  display: none;
  @media only screen and (max-width: 769px) {
    display: block;
  }
`;
